<template>
  <div style="height: 100%; position: relative">
    <div id="allpay"></div>
    <div id="hejizhichu">
      <span style="font-size: 20px; color: #50c8ff">{{
        this.utils.formatMoney(allMoney)
      }}</span>
      <p>合计支出(￥)</p>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
import { set } from "shelljs";
export default {
  data() {
    return {
      allMoney: 0,
      myData: [
         { value: 12000, name: "日常费用" },
        { value: 6000, name: "保养费" },
        { value: 8000, name: "保养费" },
        { value: 14000, name: "加油费" } 
      ],
      searchItem: {
        endTime: 0,
        startTime: 0,
        typeList: [],
      },
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      //this.getData();
    },
    drawBar(id) {
      var that = this;
      this.chart = echarts.init(document.getElementById(id), "dark");
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
          formatter: "{b}: {c}元 ({d}%)",
        },
        legend: {
          // orient: "vertical",
          //图例组件
          left: 0, //图例组件离右边的距离
          orient: "vertical", //布局  纵向布局
          //width: 40, //图行例组件的宽度,默认自适应
          x: "left", //图例显示在右边
          itemWidth: 12, //图例标记的图形宽度
          itemHeight: 12, //图例标记的图形高度
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 14,
          },
          //data: ["日常费用", "保养费", "维修费", "加油费"]
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["25%", "70%"],
            //avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: this.myData,
          },
        ],
        color: [
          "#5d97f7",
          "#06f9aa",
          "#f9c539",
          "#fa3699",
          "#64bff8",
          "#2acc4d",
          "#e860ad",
          "#e8bd60",
        ],
      };

      this.chart.setOption(this.option);

      this.chart.resize();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/cost/countCost",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        this.myData = [];
        this.allMoney = 0;
        for (let i = 0; i < data.length; i++) {
          this.myData.push({
            value: data[i].amount,
            name: data[i].type + " " + data[i].amount,
          });
          this.allMoney += data[i].amount;
        }

        this.drawBar("allpay");
      });
    },
  },
  //调用
  mounted() {
    setTimeout(()=>{
      this.drawBar("allpay");
    })
  },
};
</script>
<style lang="">
#allpay {
  width: 100%;
  height: calc(100% - 40px);
}
#hejizhichu {
  position: absolute;
  top: calc(50% - 40px);
  right: 20px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/feiyong/xunchache.vue